import { AttachmentFileType } from '../types/AttachmentFile';
import MailItemFile, { MailItemFileList } from '../types/MailItemFile';

export default function createMailItemFileForSmime(
    subject: string,
    mimeContent?: string
): MailItemFileList {
    const mailItemList: MailItemFile[] = [];

    const conversation: MailItemFile = {
        fileType: AttachmentFileType.MailItem,
        name: subject,
        size: 0,
        mimeContent: mimeContent,
    };
    mailItemList.push(conversation);
    return mailItemList;
}
